import { render, staticRenderFns } from "./ListActivityPage.vue?vue&type=template&id=518f517c&"
import script from "./ListActivityPage.vue?vue&type=script&lang=js&"
export * from "./ListActivityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports